function removeDivOnMobile() {
  if (window.innerWidth <= 767) {
    const divToRemove = document.querySelector('.desk-view');
    if (divToRemove) {
      divToRemove.remove();
    }
  } else {
     const divToRemoves = document.querySelector('.mob-view');
    if (divToRemoves) {
      divToRemoves.remove();
    }
  }
}
// Run the function when the page loads
window.addEventListener('load', removeDivOnMobile);

// Optionally, run it when the window is resized (in case the device is rotated or screen size changes)
window.addEventListener('resize', removeDivOnMobile);




document.addEventListener("DOMContentLoaded", function () {
  
  function adjustSubmenuLeftAlignment() {
    const menuItems = document.querySelectorAll(".menu-item.type_simple");

    menuItems.forEach((menuItem) => {
      const submenu = menuItem.querySelector(".menu");
      const parentContainer = menuItem.closest(".box-header-nav");

      if (submenu && parentContainer) {
        const parentWidth = parentContainer.offsetWidth;
        submenu.style.width = `${parentWidth}px`;

        const parentLeftOffset = parentContainer.getBoundingClientRect().left;
        const windowWidth = window.innerWidth;

        if (parentLeftOffset < 0) {
          submenu.style.left = `${-parentLeftOffset}px`;
        } else {
          submenu.style.left = `0`;
        }
      }
    });
  }

  function setupMenuToggle() {
    const menuItems = document.querySelectorAll(".menu-item.type_simple");

    menuItems.forEach((menuItem) => {
      const submenu = menuItem.querySelector(".menu");

      if (submenu) {
        menuItem.addEventListener("mouseenter", () => {
          //submenu.style.display = "block";
        });

        menuItem.addEventListener("mouseleave", () => {
          //submenu.style.display = "none";
        });

        menuItem.addEventListener("click", (event) => {
          if (window.innerWidth <= 768) { // Adjust breakpoint as needed
            event.preventDefault();
            //const isVisible = submenu.style.display === "block";
            //submenu.style.display = isVisible ? "none" : "block";
          }
        });
      }
    });
  }

  adjustSubmenuLeftAlignment();
  setupMenuToggle();

  window.addEventListener("resize", adjustSubmenuLeftAlignment);
});

// jQuery to hide only the specific div containing the text
$(document).ready(function () {
    $(".delivery_option").filter(function () {
        return $(this).text().trim().includes("Earliest possible delivery: 5-6 Days");
    }).hide();
});
